define('pages/content_recommendations/content_recommendations_page_view',[
  'backbone',
  'jquery',
  '_',

  'modules/content_recommendations/content_recommendations_view',
  'modules/content_recommendations/content_recommendations_filter_view',
  'text!./content_recommendations_page_template.html',
], function (
  Backbone,
  $,
  _,
  ContentRecommendationsView,
  ContentRecommendationsFilterView,
  ContentRecommendationsPageTemplate
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (options) {
      this.contentRecommendationsView = new ContentRecommendationsView();
      this.subViews.push(this.contentRecommendationsView);

      this.contentRecommendationsFilterView = new ContentRecommendationsFilterView();
      this.subViews.push(this.contentRecommendationsFilterView);

      this.render();
      this.renderSubView();

      this.listenTo(
        this.contentRecommendationsFilterView.filterModel,
        'change',
        function (model) {
          // Populating zone list
          var fullZoneOption = model.get('zoneOptions').options;
          var fullZoneList = [];

          if (fullZoneOption.length !== 0) {
            _.forEach(model.get('zoneOptions').options, function (o) {
              fullZoneList.push({ value: o.value, text: o.text });
            });
            this.contentRecommendationsView.zoneList = fullZoneList;
          }

          // Populating active filter choices
          var activeZoneOption = model.get('zoneOptions').active;
          var searchText = model.get('searchText');

          this.contentRecommendationsView.filterParams = {
            campaignPeriod: model.get('campaignPeriod'),
            campaignType: model.get('campaignType'),
            zoneOptions: activeZoneOption,
            searchText: searchText,
          };

          this.contentRecommendationsView.fetchContentRecommendations();
        }
      );
    },

    template: _.template(ContentRecommendationsPageTemplate),
    subViews: [],
    showInfoText: false,

    events: {
      'click .js-switch-content-recommendations-type':'switchContentRecommendationsType',
      'click .js-switch-content-recommendations-period':'switchContentRecommendationsPeriod',
      'click .js-toggle-infotext': 'toggleInfoText',
    },

    render: function () {
      this.$el.html(this.template({ showInfoText: this.showInfoText }));
      return this;
    },

    renderSubView: function () {
      this.$('.content-recommendations-page-content').html(this.contentRecommendationsView.$el);
      this.$('.content-recommendations-filters-content').html(this.contentRecommendationsFilterView.$el);
    },

    switchContentRecommendationsType: function (e) {
      var chosenType = e.currentTarget.dataset.type;     
      Backbone.trigger('switchType', chosenType);

      $('.js-switch-content-recommendations-type.active').removeClass('active');
      $('.js-switch-content-recommendations-type[data-type="' + chosenType + '"]').addClass('active');

      this.contentRecommendationsView.collection.params = _.extend(
        this.contentRecommendationsView.collection.params,
        {
          offset: 0,
        }
      );

      if (this.contentRecommendationsFilterView.filterModel) {
        this.contentRecommendationsFilterView.filterModel.set('campaignType', chosenType);
      }
    },

    switchContentRecommendationsPeriod: function (e) {
      var chosenPeriod = e.currentTarget.dataset.period;

      $('.js-switch-content-recommendations-period.active').removeClass('active');
      $('.js-switch-content-recommendations-period[data-period="' + chosenPeriod + '"]').addClass('active');

      this.contentRecommendationsView.collection.params = _.extend(
        this.contentRecommendationsView.collection.params,
        {
          offset: 0,
        }
      );

      if (this.contentRecommendationsFilterView.filterModel) {
        this.contentRecommendationsFilterView.filterModel.set('campaignPeriod', chosenPeriod);
      }
    },

    toggleInfoText: function () {
      this.showInfoText = !this.showInfoText;

      if (this.showInfoText) {
        this.$('.icon.icon-chevron-up').removeClass('hide');
        this.$('.icon.icon-chevron-down').addClass('hide');
        this.$('.panel-info-text').removeClass('hide');
        this.$('.page-actions').removeClass('is-top');
      } else {
        this.$('.icon.icon-chevron-up').addClass('hide');
        this.$('.icon.icon-chevron-down').removeClass('hide');
        this.$('.panel-info-text').addClass('hide');
        this.$('.page-actions').addClass('is-top');
      }
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});
